// extracted by mini-css-extract-plugin
export default {"container":"style_container__wrjbB","content":"style_content__+d27C"};